import Const from '../../../util/Constants';

const ThirdParties = {
  lead: [
    { id: Const.Acre99, name: '99Acres', img: '/images/third-party/99acres.jpg', link: '99acres', status: 1 },
    { id: Const.Magicbricks, name: 'Magicbricks', img: '/images/third-party/magicBricks.png', link: 'magicbricks', status: 1 },
    { id: Const.Housing, name: 'Housing', img: '/images/third-party/housings.png', link: 'housing', status: 1 },
    { id: Const.RealestateIndia, name: 'Realestate India', img: '/images/third-party/realestateIndia.png', link: 'realestate-india', status: 1 },
    { id: Const.Justdial, name: 'Justdial', img: '/images/third-party/justdial.svg', link: 'justdial', status: 2 },
    { id: Const.Sulekha, name: 'Sulekha', img: '/images/third-party/sulekha.png', link: 'sulekha', status: 1 }
  ],
  aiIntegration: [
    { id: 1000, name: 'Sarvan AI', img: '/images/third-party/sarvan_ai.jpg', link: 'ai-integration', status: 1 },
    { id: 1001, name: 'Floatbot AI', img: '/images/third-party/floatbot_ai.png', link: 'ai-integration', status: 1 },
    { id: 1002, name: 'Speechnotes AI', img: '/images/third-party/speechnotes_ai.jpg', link: 'ai-integration', status: 1 },
    { id: 1003, name: 'Vapi AI', img: '/images/third-party/vapi_ai.png', link: 'ai-integration', status: 1 },
    { id: 1004, name: 'Corover AI', img: '/images/third-party/CoRover.ai_.png', link: 'ai-integration', status: 1 },
    { id: 1005, name: 'Verloop AI', img: '/images/third-party/vreloop_ai.png', link: 'ai-integration', status: 1 },
    { id: 1006, name: 'Nurix AI', img: '/images/third-party/nurix_ai.png', link: 'ai-integration', status: 1 },
    { id: 1007, name: 'mailmeteor AI', img: '/images/third-party/mailmeteor.jpeg', link: 'ai-integration', status: 1 },
    { id: 1008, name: 'Awaz AI', img: '/images/third-party/awaz_ai.jpeg', link: 'ai-integration', status: 1 },
    { id: 1009, name: 'Haptik AI', img: '/images/third-party/haptik_ai.webp', link: 'ai-integration', status: 1 },
    { id: 1010, name: 'Squadstack AI', img: '/images/third-party/squadstack_ai.jpeg', link: 'ai-integration', status: 1 },
    { id: 1011, name: 'Bolna AI', img: '/images/third-party/bolna_ai.png', link: 'ai-integration', status: 1 },
    { id: 1012, name: 'Pulse AI', img: '/images/third-party/pulse_ai.webp', link: 'ai-integration', status: 1 },
    { id: 1013, name: 'Gupshup AI', img: '/images/third-party/gupshup.png', link: 'ai-integration', status: 1 },
    { id: 1014, name: 'Elevenlabs AI', img: '/images/third-party/elevenlabs_ai.webp', link: 'ai-integration', status: 1 }
  ],
  cloud: [
    { id: Const.Ozonetel, name: 'Ozonetel', img: '/images/third-party/ozontel.jpg', link: 'ozonetel', status: 1 },
    { id: Const.Exotel, name: 'Exotel', img: '/images/third-party/exotel.png', link: 'exotel', status: 1 },
    { id: Const.TataTeleservices, name: 'Tata Teleservices', img: '/images/third-party/tatatele.png', link: 'tatatele', status: 1 },
    { id: Const.MyOperator, name: 'My Operator', img: '/images/third-party/myop.png', link: 'myop', status: 1 },
    { id: Const.Mcube, name: 'Mcube', img: '/images/third-party/vmc_mcube_logo.jpeg', link: 'mcube', status: 1 },
    { id: Const.TeleCMI, name: 'TeleCMI', img: '/images/third-party/telecmi.webp', link: 'telecmi', status: 1 }
  ],
  whatsapp: [
    { id: Const.WhatsApp, name: 'WhatsApp', img: '/images/third-party/whatsappp.png', link: 'whats-app', status: 1 },
    { id: Const.Interakt, name: 'Interakt', img: '/images/third-party/interakt.webp', link: 'interakt', status: 1 },
    { id: Const.AiSensy, name: 'AiSensy', img: '/images/third-party/aisensy.png', link: 'aisensy', status: 1 },
    { id: Const.Wati, name: 'Wati', img: '/images/third-party/wati.svg', link: 'Wati', status: 1 },
    { id: Const.DoubleTick, name: 'Double Tick', img: '/images/third-party/double_tick.png', link: 'double-tick', status: 1 },
    { id: Const.TheUltimate, name: 'TheUltimate', img: '/images/third-party/theultimate.png', link: 'the-ultimate', status: 1 },
    { id: Const.MsgClub, name: 'Msg Club', img: '/images/third-party/msglogo.png', link: 'msg-club', status: 1 },
    { id: Const.DaveSoft, name: 'Dave Soft', img: '/images/third-party/dave_soft.png', link: 'dave-soft', status: 1 }
  ],
  webhook: [  
    { id: Const.Webhook, name: 'Webhookes', img: '/images/third-party/webhooks.png', link: 'webhooks', status: 1 },
    { id: Const.GoogleAds, name: 'Google Ads', img: '/images/third-party/ads.png', link: 'google-ads', status: 1 },
    { id: Const.Forms, name: 'Google Forms', img: '/images/third-party/google-forms.jpg', link: 'google-forms', status: 1 }
  ],
  social: [
    { id: Const.Facebook, name: 'Facebook', img: '/images/third-party/fb.png', link: 'facebook', status: 1 },
    { id: Const.Instgram, name: 'Instgram', img: '/images/third-party/instagram.jpg', link: 'instgram', status: 1 },
    { id: Const.LinkedIn, name: 'LinkedIn', img: '/images/third-party/ld.png', link: 'linked-in', status: 1 }
  ],
  ecommerce: [
    { id: Const.Wordpress, name: 'WordPress', img: '/images/third-party/wordpress.png', link: 'word-press', status: 1 },
    { id: Const.Instgram, name: 'Shopify', img: '/images/third-party/shopify.png', link: 'shopify', status: 1 },
    { id: Const.Wix, name: 'Wix', img: '/images/third-party/wix.png', link: 'wix', status: 1 }
  ],
  paymentGateway: [
    { id: Const.Razorpay, name: 'Razorpay', img: '/images/third-party/razorpay.jpg', link: 'razorpay', status: 1 },
    { id: Const.Payu, name: 'PayU', img: '/images/third-party/payu2.jpeg', link: 'payu', status: 1 },
    { id: Const.Stripe, name: 'Stripe', img: '/images/third-party/stripe2.png', link: 'stripe', status: 1 },
  ],
  kyc: [
    { id: Const.VerifyUser, name: 'Verify User', img: '/images/third-party/verifyUser.jpg', link: 'verify-user', status: 1 },
    { id: Const.Digio, name: 'Digio', img: '/images/third-party/digio.png', link: 'digio', status: 1 },
  ],
  email: [
    { id: Const.MailChimp, name: 'MailChimp', img: '/images/third-party/mailchimp.png', link: 'mail-chimp', status: 1 },
    { id: Const.Brevo, name: 'Brevo', img: '/images/third-party/brevo.png', link: 'brevo', status: 1 },
    { id: Const.Sendgrid, name: 'SendGrid', img: '/images/third-party/sendgrid.png', link: 'sendgrid', status: 1 },
    { id: Const.Microsoft365, name: 'Microsoft365', img: '/images/third-party/microsoft365.jpeg', link: 'microsoft365', status: 1 },
    { id: Const.Gmail, name: 'Gmail', img: '/images/third-party/gmail1.png', link: 'gmail', status: 1 },
  ],
  accounts: [
    { id: Const.Busy, name: 'Busy', img: '/images/third-party/busy.png', link: 'busy', status: 1 },
    { id: Const.Quickbook, name: 'QuickBooks', img: '/images/third-party/quickbook.webp', link: 'quick-books', status: 1 },
  ],
  sms: [
    { id: Const.TextLocal, name: 'TextLocal', img: '/images/third-party/textLocal.jpg', link: 'text-local', status: 1 },
    { id: Const.Gupshup, name: 'Gupshup', img: '/images/third-party/gupshup.png', link: 'gupshup', status: 1 },
  ],

};
export default ThirdParties;
